import ReactDOM from "react-dom/client";
import React from "react";
import ProductsPage from "./components/ProductsPage.tsx";
import '../../i18n/i18n'; // Initialize i18n

const productPageRoot = document.querySelector<HTMLElement>('#products-page-root');
if (productPageRoot) {
  ReactDOM.createRoot(productPageRoot).render(
    <React.StrictMode>
      <ProductsPage />
    </React.StrictMode>
  );
}